import * as _ from 'lodash';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Col, Form, Row } from 'reactstrap';
import { IFile, IProject, IProposition } from 'src/model';
import { declineProposition, getProjectFileUrl, proposeProposition } from 'src/services';
import { FileItem } from '../shared/Files/FileItem';
import { ProjectTypeConfig } from '../shared/Input/ProjectTypeList';
import { ModalPortal } from '../shared/Modals/ModalPortal';
import { PropositionDeletionModal } from '../shared/Modals/PropositionDeletionModal';
import { Svg } from '../shared/Svg';




interface IProjectDisplayProps {
  project: IProject;
  proposition: IProposition;
  handlePropositionChange: (proposition: IProposition) => void;
}

const ProjectDisplay: React.SFC<IProjectDisplayProps & RouteComponentProps> = ({
  handlePropositionChange,
  history,
  project,
  proposition,
}) => {
  const [validationModalIsOpen, setValidationModal] = React.useState(false);

  const toggleValidationModal = () =>
    setValidationModal(!validationModalIsOpen);

  const getProjectTypeSrc = (label: string) => {
    const projectType = _.find(ProjectTypeConfig, { label });
    return projectType ? projectType.src : 'project/expertise-conseil';
  };

  const getFileUrl = (fileUuid: string) =>
    getProjectFileUrl(project._id, fileUuid);
  const isHidden = proposition.meta.status === 'hidden';

  const handlePropositionCreation = async () => {
    const updatedProposition = await proposeProposition(proposition._id);
    if (updatedProposition) {
      handlePropositionChange(updatedProposition);
      history.push(`/project/${project._id}/proposition`);
    }
  };

  const handlePropositionDecline = async () => {
    const updatedProposition = await declineProposition(proposition._id);
    if (updatedProposition) {
      handlePropositionChange(updatedProposition);
      history.push(`/dashboard/`);
    }
  };

  return (
    <>
      <Form className='p-5'>
        <Row>
          <Col md='8'>
            <Row>
              <Col xs='2' className='d-flex flex-column align-items-center'>
                <div
                  className='d-flex flex-column align-items-center bg-primary mt-2'
                  style={{ height: '48px', width: '48px' }}
                >
                  <Svg
                    width={32}
                    height={32}
                    fill='white'
                    src={getProjectTypeSrc(project.projectType[0])}
                    className='mt-2'
                  />
                </div>
                <span
                  className='d-block text-center mt-2'
                  style={{ fontSize: '10px' }}
                >
                  {project.projectType[0]}
                </span>
              </Col>
              <Col xs='10 pl-4 pr-5'>
                <Row>
                  <span className='text-dark' style={{ fontSize: '32px' }}>
                    {project.title}
                  </span>
                </Row>
                 {project.subtype && (
                  <Row className='text-dark mt-2'>
                    {project.subtype.map((subtype , key: number) => (
                    <span key={key} >{subtype.value}</span>
                    ))}
                  </Row>
                )} 
                <Row className='mt-4'>
                  <span>{project.description}</span>
                </Row>
              </Col>
            </Row>
             {project.functionalSkills && (
              <Row className='pt-5'>
                <Col className='d-flex justify-content-end' xs='2'>
                  <Svg width={32} height={32} fill='primary' src='skills' />
                </Col>
                <Col xs='10 pl-4 pr-5'>
                  <Row className='d-flex text-dark'>
                    <span className='text-primary font-weight-bold'>
                      Compétences fonctionnelles recherchées
                    </span>
                  </Row>
                  <Row className='d-flex text-dark'>
                    {project.functionalSkills.map((functionalSkills , key: number) => (
                    <span key={key}  style={{ backgroundColor: '#dce8f2', borderRadius: '1rem' , padding : '6px' , margin : '2px'}}>{functionalSkills.value}</span>
                    ))}
                  </Row>
                </Col>
              </Row>
            )} 
             {project.technicalSkills && (
              <Row className='pt-5'>
                <Col className='d-flex justify-content-end' xs='2'>
                  <Svg width={32} height={32} fill='primary' src='skills' />
                </Col>
                <Col xs='10 pl-4 pr-5'>
                  <Row className='d-flex text-dark'>
                    <span className='text-primary font-weight-bold'>
                      Compétences techniques recherchées
                    </span>
                  </Row>
                  <Row className='d-flex text-dark'>
                    {project.technicalSkills.map((technicalSkills , key: number) => (
                    <span key={key} style={{ backgroundColor: '#dce8f2', borderRadius: '1rem' , padding : '6px' , margin : '2px'}} >{technicalSkills.value}</span>
                    ))}
                  </Row>
                </Col>
              </Row>
            )} 
             {project.deliverable && (
              <Row className='pt-5'>
                <Col xs='2' className='d-flex justify-content-end'>
                  <Svg
                    width={32}
                    height={32}
                    fill='primary'
                    src='deliverable'
                  />
                </Col>
                <Col xs='10 pl-4 pr-5'>
                  <Row className='d-flex text-dark'>
                    <span className='text-primary font-weight-bold'>
                      Livrables attendus
                    </span>
                  </Row>
                  <Row className='d-flex text-dark'>
                    {project.deliverable.map((deliverable , key: number) => (
                    <span key={key} style={{ backgroundColor: '#dce8f2', borderRadius: '1rem' , padding : '6px' , margin : '2px'}}>{deliverable.value}</span>
                    ))}
                  </Row>
                </Col>
              </Row>
            )} 
            {project.files && (
              <Row className='pt-5'>
                <Col xs='2' className='d-flex justify-content-end'>
                  <Svg width={32} height={32} fill='primary' src='attachment' />
                </Col>
                <Col xs='10 pl-4 pr-5'>
                  <Row className='d-flex flex-column text-dark'>
                    <span className='text-primary font-weight-bold'>
                      Pièces jointes
                    </span>
                    <Row className='pt-3'>
                      {project.files.map((file: IFile, key: number) => (
                        <Col key={key} xs='2'>
                          <FileItem
                            edit={false}
                            file={file}
                            getFileUrl={getFileUrl}
                            handleFileDelete={() => {
                              return;
                            }}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Row>
                </Col>
              </Row>
            )}
          </Col>
          <Col md='4' className='bg-white p-5 h-100'>
            {project.startingDate && (
              <Row className='d-flex flex-column align-items-center'>
                <span
                  className='text-uppercase text-grey'
                  style={{ fontSize: '10px', opacity: 0.5 }}
                >
                  Date de démarrage souhaitée
                </span>
                <span className='text-secondary' style={{ fontSize: '24px' }}>
                  {new Date(project.startingDate).toLocaleDateString()}
                </span>
              </Row>
            )}
             {project.duration && (
              <Row className='d-flex flex-column align-items-center mt-5'>
                <span
                  className='text-uppercase text-grey'
                  style={{ fontSize: '10px', opacity: 0.5 }}
                >
                  Durée estimée
                </span>
                <span className='text-secondary' style={{ fontSize: '24px' }}>
                {project.duration.map((duration , key: number) => (
                    <span key={key } >{duration.value}</span>
                    ))}
                </span>
              </Row>
            )}
            {project.place && (
              <Row className='d-flex flex-column align-items-center mt-5'>
                <span
                  className='text-uppercase text-grey'
                  style={{ fontSize: '10px', opacity: 0.5 }}
                >
                  Forfait ou régie ?
                </span>
                 <span className='text-secondary' style={{ fontSize: '24px' }}>
                 {project.place.map((place , key: number) => (
                    <span key={key } >{place.value}</span>
                    ))}
                </span> 
              </Row>
            )}
            {(project.budgetMax || project.dailyPriceMax) && (
              <Row className='d-flex flex-column align-items-center mt-5'>
                <span
                  className='text-uppercase text-grey'
                  style={{ fontSize: '10px', opacity: 0.5 }}
                >
                  Budget
                </span>
                <span className='text-secondary' style={{ fontSize: '24px' }}>
                  {project.place && project.place[0].value === 'Forfait'
                    ? `${project.budgetMin ? project.budgetMin : 0}€ - ${
                        project.budgetMax ? project.budgetMax : 0
                      }€`
                    : `${
                        project.dailyPriceMin ? project.dailyPriceMin : 0
                      }€/jour - ${project.dailyPriceMax}€/jour`}
                </span>
              </Row>
            )}
            {project.localisation && project.localisation.label && (
              <Row className='d-flex flex-column align-items-center mt-5'>
                <span
                  className='text-uppercase text-grey'
                  style={{ fontSize: '10px', opacity: 0.5 }}
                >
                  Localisation
                </span>
                <span className='text-secondary' style={{ fontSize: '24px' }}>
                  {project.localisation.label}
                </span>
              </Row>
            )}
          </Col>
        </Row>
        <Row className='d-flex justify-content-between mt-5'>
          <Col md='3'>
            <Link to='/dashboard'>
              <Button className='text-uppercase text-white bg-dark border-0'>
                Retour aux projects
              </Button>
            </Link>
          </Col>
          {isHidden && (
            <Col md='5'>
              <Button
                className='text-uppercase text-white bg-dark border-0'
                style={{ opacity: 0.5 }}
                onClick={toggleValidationModal}
              >
                Décliner
              </Button>
              <Button
                className='text-uppercase text-white bg-success border-0 float-right'
                onClick={handlePropositionCreation}
              >
                Créer une proposition
              </Button>
            </Col>
          )}
        </Row>
      </Form>
      <ModalPortal>
        <PropositionDeletionModal
          isOpen={validationModalIsOpen}
          handleSave={handlePropositionDecline}
          toggleValidationModal={toggleValidationModal}
        />
      </ModalPortal>
    </>
  );
};

export const ProjectDisplayWithRouter = withRouter(ProjectDisplay);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDisplay.tsx